import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const HtmlRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the current path contains .html
    if (location.pathname.includes('.html')) {
      // Redirect to home page
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  return null; // This component doesn't render anything
};

export default HtmlRedirect;
